module.exports = __webpack_public_path__ + "8b6629d91236f5d18d9c6ef78612c6e1.svg";